export default "__VITE_ASSET__DTA6z38W__"